<template lang="html">
  <div>
    <div class="relative z-10" v-show="!isRecording">
      <div class="bg-white dark:bg-gray-800 shadow-lg flex py-1 px-4 rounded-lg">
        <div class="float-left text-center flex justify-center w-2/5">
          <div class="grid gap-1 py-1" :class="isMirrorPlus ? 'grid-flow-col grid-rows-2' : 'grid-cols-2'">
            <div data-tippy-content="Turn off/on your camera." class="text-xs uppercase bold text-gray-600 tracking-wider flex items-center justify-center">
              <div class="">
                Video
                <div class="form-switch ml-2" id="muteVideoFeed" data-id="camera">
                  <input type="checkbox" checked>
                  <i></i>
                </div>
              </div>
            </div>
            <div data-tippy-content="Turn off/on your camera audio." class="text-xs uppercase bold text-gray-600 tracking-wider flex items-center justify-center">
              <div class="">
                Audio
                <div class="form-switch ml-2 muteMicrophone" data-id="camera">
                  <input type="checkbox">
                  <i></i>
                </div>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-3 gap-1 px-2 rounded-md w-3/5 justify-center" v-if="isMirrorPlus">
            <div class="flex flex-col justify-center">
              <vertical-stepper :stepper-value.sync="selectedRoll" :is-alphanumeric="true"></vertical-stepper>
              <label class="text-sm text-gray-600">Roll</label>
            </div>
            <div class="flex flex-col justify-center">
              <vertical-stepper :stepper-value.sync="selectedScene"></vertical-stepper>
              <label class="text-sm text-gray-600">Scene</label>
            </div>
            <div class="flex flex-col justify-center">
              <vertical-stepper :stepper-value.sync="selectedShot"></vertical-stepper>
              <label class="text-sm text-gray-600">Shot</label>
            </div>
            <div class="mt-5 hidden">
              <div class="text-xl font-medium mt-px">1</div>
              <label class="mt-5 pt-px text-sm text-gray-600">Take</label>
            </div>
          </div>
        </div>
        <div class="text-center w-1/5" v-if="isMirrorPlus">
          <div id="activated-container">
            <button data-tippy-content="Start recording." class="btn btn-red text-xl px-5 py-6 rounded-full" @click="toggleRecording" :disabled="!this.canRecord" style="width: 76px; height: 76px;">
            REC
            </button>
          </div>
        </div>
        <div class="flex space-x-2 justify-end" :class="isMirrorPlus ? 'w-2/5' : 'w-3/5'">
          <div class="w-32 py-2 flex flex-col">
            <select @change="$emit('mask-viewport', aspectRatio); showARLabels = false;" @click="showARLabels = true;" v-model="aspectRatio" class="form-input pr-10 h-full">
              <option v-for="ar in supportedAspectRatios" :value="ar.value" v-html="ar.value" :aria-label="showARLabels ? '  ' + ar.label : ''"></option>
            </select>
            <button class="mt-1 btn btn-secondary w-full py-1 text-center" @click="rotateViewport()" aria-label="rotate viewport 90 degrees to the left">
            <!-- Rotate view icon -->
            <svg class="w-4 h-4 fill-current inline-block" width="22" height="29" viewBox="0 0 22 29" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7071 0.29289C12.0976 0.68342 12.0976 1.31658 11.7071 1.70711L9.41421 4H15C18.866 4 22 7.134 22 11V13C22 13.5523 21.5523 14 21 14C20.4477 14 20 13.5523 20 13V11C20 8.2386 17.7614 6 15 6H9.41421L11.7071 8.2929C12.0976 8.6834 12.0976 9.3166 11.7071 9.7071C11.3166 10.0976 10.6834 10.0976 10.2929 9.7071L6.29289 5.70711C5.90237 5.31658 5.90237 4.68342 6.29289 4.29289L10.2929 0.29289C10.6834 -0.09763 11.3166 -0.09763 11.7071 0.29289Z"/>
              <path d="M1 13V28H16V13H1Z" stroke-width="2"/>
            </svg>
            Rotate
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- recording button -->
    <div v-show="isRecording" class="-mt-5 relative z-10 flex items-center justify-center" v-if="isMirrorPlus">
        <button class="btn btn-red text-xl px-4 py-2 rounded-md flex items-center" @click="toggleRecording">
          <svg class="fill-current h-8 w-8 mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M16 4.995v9.808c0 .661-.536 1.197-1.196 1.197H4.997A.997.997 0 0 1 4 15.003V5.196C4 4.536 4.536 4 5.196 4h9.808c.55 0 .996.446.996.995z"/></svg>
          Stop recording
        </button>
    </div>
  </div>
</template>
<script>
import {startVideoRecording, stopVideoRecording} from 'mirror/videorecordings'
import commandsManager from 'general/CommandsManager'
import axios from "axios";

export default {
  props: {
    roomActivated: {
      type: Boolean,
      required:  false
    },
    tempHideCamera: {
      type: Boolean,
      required:  false
    },
    isMirrorPlus: {
      type: Boolean,
      required:  true
    },
  },
  data() {
    return {
      isRecording: false,
      selectedRoll: "1",
      selectedScene: "1",
      selectedShot: "1",
      stopRecordTimeOutFunc: null,
      canRecord: true,
      maxRecordingTime: 0, // milliseconds (600,000 should be 10 min, 7,200,000 for 2h)
      angle: 0,
      aspectRatio: '16:9',
      showARLabels: false,
      supportedAspectRatios: [
        {
          value: '16:9',
          label: 'Default'
        },
        {
          value: '2:3',
          label: 'FB post'
        },
        {
          value: '4:5',
          label: 'IG+FB post'
        },
        {
          value: '1:1',
          label: 'Square post'
        },
        {
          value: '4:3',
          label: 'TV'
        },
        {
          value: '1.91:1',
          label: 'IG Videos'
        },
      ]
    }
  },
  watch: {
    tempHideCamera(){
      if ($("#muteVideoFeed[data-id='camera'] input").is(':checked') == this.tempHideCamera){
        $("#muteVideoFeed[data-id='camera']").click()
      }
    }
  },
  mounted() {
    this.updateRestrictions();
    this.$root.$on('roomActivated', () => {
      if(this.isRecording){
        clearTimeout(this.stopRecordTimeOutFunc);
        this.stopRecordTimeOutFunc = setTimeout(this.stopRecording, Math.min(this.maxRecordingTime, window.activeUntil));
      }
    })

    commandsManager.registerNewCommand('start_video_recording', () => {
      this.toggleRecording()
    })
    commandsManager.registerNewCommand('stop_video_recording', () => {
      this.toggleRecording()
    })
  },
  methods: {
    setRollSceneShot(roll, scene, shot){
      this.selectedRoll = roll;
      this.selectedScene = scene;
      this.selectedShot = shot;
    },
    toggleRecording() {
      if(!this.roomActivated){
        alert('Session is not activated yet. Please, activate the room to enable video recording')
        return;
      }
      // a folder must be selected to record a video
      if(this.maxRecordingTime <= 0){
        alert('You have reached your limit of 20 min of uploads');
        return;
      }
      if (!this.isRecording) {
        // check if a folder is selected
        this.isRecording = startVideoRecording();
        if (this.isRecording){ this.$emit("is-recording", true); this.canRecord = false}
        else{
          this.$emit("create-take-folder", true);
        }
        let activeUntil = parseInt(window.activeUntil * 1000) - new Date();
        this.stopRecordTimeOutFunc = setTimeout(this.stopRecording, Math.min(this.maxRecordingTime, activeUntil));
      } else {
        this.stopRecording();
        clearTimeout(this.stopRecordTimeOutFunc);
      }
    },
    stopRecording() {
      stopVideoRecording(this.selectedRoll, this.selectedScene, this.selectedShot, this.angle, this.aspectRatio, json => {
        // emit to video-takes-list component
        this.$root.$emit('videoRecordUploaded', json)
        this.canRecord = true;
        this.updateRestrictions();
      })
      this.isRecording = false;
      this.$emit("is-recording", false);
    },
    updateRestrictions(){
      axios.get('/video_takes/restrictions').then(response => {
        if(response.data.is_trial){
          this.maxRecordingTime = 600_000 - response.data.total_record_time;
        }else{
          this.maxRecordingTime = 7_200_000;
        }
      }).catch(error => {
        console.log(error);
      })
    },
    rotateViewport(){
      this.angle = this.angle + 90;
      this.aspectRatio = "16:9"
      this.$emit('mask-viewport', this.aspectRatio)
      if(this.angle >= 360) this.angle = 0;
      this.$emit("rotate-viewport");
    }
  },
}
</script>
<style lang="">

</style>
